import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { ButtonTertiary, IconArrowRight, IconDownload, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
const SendOrDownloadButtonStyled = styled(ButtonTertiary) `
  color: black;
  &:active:hover,
  &:hover {
    color: black;
  }
  &:disabled {
    color: #878787;
  }
`;
const useDownloadTranscriptEnabled = () => {
    const DOUBLE_CLICK_DELAY_MILLISECONDS = 450;
    const [downloadTranscriptEnabled, setDownloadTranscriptEnabled] = useState(true);
    const timeoutRef = useRef(undefined);
    useEffect(function cleanupOnComponentUnmount() {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const delayDownloadTranscriptEnabled = useCallback(() => {
        setDownloadTranscriptEnabled(false);
        timeoutRef.current = setTimeout(() => {
            setDownloadTranscriptEnabled(true);
        }, DOUBLE_CLICK_DELAY_MILLISECONDS);
    }, []);
    return {
        downloadTranscriptEnabled,
        delayTranscriptEnabled: delayDownloadTranscriptEnabled,
    };
};
export const SendOrDownloadButton = ({ disabledDownloadButton = false, disabledSendMessageButton = false, state, onDownloadClick, onSendClick, }) => {
    const { downloadTranscriptEnabled, delayTranscriptEnabled } = useDownloadTranscriptEnabled();
    const handleSendMessage = useCallback((ev) => {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        delayTranscriptEnabled();
        onSendClick === null || onSendClick === void 0 ? void 0 : onSendClick();
    }, [onSendClick, delayTranscriptEnabled]);
    const handleDownloadTranscript = useCallback(ev => {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        if (downloadTranscriptEnabled) {
            onDownloadClick === null || onDownloadClick === void 0 ? void 0 : onDownloadClick();
        }
    }, [onDownloadClick, downloadTranscriptEnabled]);
    return state === 'send' ? (React.createElement(SendOrDownloadButtonStyled, { "data-testid": "message-send-button", disabled: disabledSendMessageButton, type: "button", "aria-label": "send message", iconOnly: IconArrowRight, onClick: handleSendMessage })) : (React.createElement(SendOrDownloadButtonStyled, { "data-testid": "download-transcript-button", disabled: disabledDownloadButton && !downloadTranscriptEnabled, type: "button", "aria-label": "download transcript", iconOnly: IconDownload, onClick: handleDownloadTranscript }));
};
